export default "https://statics.cloudfastin.top/static/v1.27.25.1/store/images/twitter.png?ef2d37550de4dca957d931ae9f5b932d";